import React from "react";

function AddVehicleForm({ newVehicle, setNewVehicle, handleAddVehicle }) {
  return (
    <form
      onSubmit={handleAddVehicle}
      className="bg-white shadow-md p-4 rounded-lg mb-6 space-y-3 max-w-xl"
    >
      <h3 className="text-lg font-medium mb-2">Add New Vehicle</h3>

      <label className="block font-medium">Model</label>
      <input
        type="text"
        value={newVehicle.model}
        onChange={(e) => setNewVehicle({ ...newVehicle, model: e.target.value })}
        className="w-full border border-gray-300 px-3 py-2 rounded"
        required
      />

      <label className="block font-medium">Year</label>
      <input
        type="number"
        min="1900"
        max={new Date().getFullYear()}
        value={newVehicle.year}
        onChange={(e) => setNewVehicle({ ...newVehicle, year: e.target.value })}
        className="w-full border border-gray-300 px-3 py-2 rounded"
        required
      />

      <label className="block font-medium">Type</label>
      <select
        value={newVehicle.type}
        onChange={(e) => setNewVehicle({ ...newVehicle, type: e.target.value })}
        className="w-full border border-gray-300 px-3 py-2 rounded"
        required
      >
        <option value="">Select Type</option>
        <option value="Sedan">Sedan</option>
        <option value="SUV">SUV</option>
        <option value="Van">Van</option>
      </select>

      <label className="block font-medium">Price Per Day ($)</label>
      <input
        type="number"
        min="1"
        step="0.01"
        value={newVehicle.price_per_day}
        onChange={(e) =>
          setNewVehicle({ ...newVehicle, price_per_day: e.target.value })
        }
        className="w-full border border-gray-300 px-3 py-2 rounded"
        required
      />

      <label className="block font-medium">Seats</label>
      <input
        type="number"
        min="1"
        max="20"
        value={newVehicle.seats || ""}
        onChange={(e) => setNewVehicle({ ...newVehicle, seats: parseInt(e.target.value) || "" })}
        className="w-full border border-gray-300 px-3 py-2 rounded"
        required
      />

      <label className="block font-medium">Image URL</label>
      <input
        type="text"
        value={newVehicle.image_url}
        onChange={(e) => setNewVehicle({ ...newVehicle, image_url: e.target.value })}
        className="w-full border border-gray-300 px-3 py-2 rounded"
        required
      />

      <button
        type="submit"
        className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
      >
        Add Vehicle
      </button>
    </form>
  );
}

export default AddVehicleForm;
